export default "__VITE_ASSET__DJReu$bW__"